export const formaDJRCyrillicMicroFontFamily = 'FormaDJRCyrillicMicro'
export const formaDJRCyrillicTextFontFamily = 'FormaDJRCyrillicText'
